// @flow

const TreeShakingTest = () => console.log("TestKey: TreeShakingTest");

export default TreeShakingTest;
